@let token = continuationToken();
@if (token) {
  <div class="grid">
    <div id="trigger" #btnLoadMore></div>
    <button type="button" mat-button (click)="loadMore.emit(token)">
      <mat-icon>unfold_more</mat-icon>
      Mehr laden
    </button>
  </div>
} @else if (loading()) {
  @defer (on timer(500ms)) {
    <div class="grid">
      <mat-icon class="spin">progress_activity</mat-icon>
    </div>
  }
}
